import axios from 'axios';
import { setAlert } from './alert';

import {
    ADD_COMMENT,
    ADD_POST,
    DELETE_POST,
    GET_POST,
    GET_POSTS,
    POST_ERROR,
    REMOVE_COMMENT,
    UPDATE_LIKES,
} from './types';

const baseUrl =
    process.env.BASE_URL || 'https://devconnector-hr6s.onrender.com';

// Get posts
export const getPosts = () => async (dispatch) => {
    try {
        const res = await axios.get(`${baseUrl}/api/posts`);

        dispatch({
            type: GET_POSTS,
            payload: res.data,
        });
    } catch (err) {
        dispatch({
            type: POST_ERROR,
            payload: {
                msg: err.response.messageText,
                status: err.response.status,
            },
        });
    }
};

// Add like
export const addLike = (postId) => async (dispatch) => {
    try {
        const res = await axios.put(`${baseUrl}/api/posts/like/${postId}`);

        dispatch({
            type: UPDATE_LIKES,
            payload: { id: postId, likes: res.data },
        });
    } catch (err) {
        dispatch({
            type: POST_ERROR,
            payload: {
                msg: err.response.messageText,
                status: err.response.status,
            },
        });
    }
};

// Remove like
export const removeLike = (postId) => async (dispatch) => {
    try {
        const res = await axios.put(`${baseUrl}/api/posts/unlike/${postId}`);

        dispatch({
            type: UPDATE_LIKES,
            payload: { id: postId, likes: res.data },
        });
    } catch (err) {
        dispatch({
            type: POST_ERROR,
            payload: {
                msg: err.response.messageText,
                status: err.response.status,
            },
        });
    }
};

// Delete Post
export const deletePost = (id) => async (dispatch) => {
    try {
        await axios.delete(`${baseUrl}/api/posts/${id}`);

        dispatch({
            type: DELETE_POST,
            payload: id,
        });

        dispatch(setAlert('Post Removed', 'success'));
    } catch (err) {
        dispatch({
            type: POST_ERROR,
            payload: {
                msg: err.response.messageText,
                status: err.response.status,
            },
        });
    }
};

// Add Post
export const addPost = (formData) => async (dispatch) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    // const body = JSON.stringify(formData);

    try {
        const res = await axios.post(`${baseUrl}/api/posts`, formData, config);

        dispatch({
            type: ADD_POST,
            payload: res.data,
        });

        dispatch(setAlert('Post Created', 'success'));
    } catch (err) {
        dispatch({
            type: POST_ERROR,
            payload: {
                msg: err.response.messageText,
                status: err.response.status,
            },
        });
    }
};

// Get a post
export const getPost = (id) => async (dispatch) => {
    try {
        const res = await axios.get(`${baseUrl}/api/posts/${id}`);

        dispatch({
            type: GET_POST,
            payload: res.data,
        });
    } catch (err) {
        dispatch({
            type: POST_ERROR,
            payload: {
                msg: err.response.messageText,
                status: err.response.status,
            },
        });
    }
};

// Add Comment
export const addComment = (postId, formData) => async (dispatch) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    // const body = JSON.stringify(formData);

    try {
        const res = await axios.post(
            `${baseUrl}/api/posts/comment/${postId}`,
            formData,
            config
        );

        dispatch({
            type: ADD_COMMENT,
            payload: res.data,
        });

        dispatch(setAlert('Comment Added', 'success'));
    } catch (err) {
        dispatch({
            type: POST_ERROR,
            payload: {
                msg: err.response.messageText,
                status: err.response.status,
            },
        });
    }
};

// Delete Comment
export const deleteComment = (postId, commentId) => async (dispatch) => {
    try {
        await axios.delete(
            `${baseUrl}/api/posts/comment/${postId}/${commentId}`
        );

        dispatch({
            type: REMOVE_COMMENT,
            payload: commentId,
        });

        dispatch(setAlert('Comment Removed', 'success'));
    } catch (err) {
        dispatch({
            type: POST_ERROR,
            payload: {
                msg: err.response.messageText,
                status: err.response.status,
            },
        });
    }
};
